import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { formatAmount } from '@betty/toolkit/utils';
import { Button, InfoImage } from '@betty/moonlight';
import { WithdrawInsufficientFundsProps } from './WithdrawInsufficientFunds.types';

function WithdrawInsufficientFunds({
  minAmount,
  close,
}: WithdrawInsufficientFundsProps) {
  const { t } = useTranslation('wallet');

  return (
    <InfoImage
      title={t('insufficientFundsTitle')}
      description={t('insufficientFundsDescription', {
        minAmount: formatAmount(minAmount),
      })}
    >
      <Button
        variant="secondary"
        locKey="close"
        locNS="common"
        size="large"
        width="100%"
        onPress={close}
      />
    </InfoImage>
  );
}

export default memo(WithdrawInsufficientFunds);
